import React from "react";
import styling from "./UserCart.module.css";
import { useDispatch, useSelector } from "react-redux";
import { removeCustomerItems } from "../../../../../redux/actions/actions";
import { AiOutlineDelete } from "react-icons/ai";
import { notify, ToastContainer } from "../../../../Notify/Notify";
import { useEffect } from "react";
import { useState } from "react";

function UserCart({ hideAction, guestUser }) {
  let userCart = useSelector((state) => state.userCart);
  let [cartTotal, setCartTotal] = useState(0);

  let dispatch = useDispatch();
  let deleteItem = (details) => {
    if (window.confirm("Are you sure you want to delete this item ?")) {
      dispatch(removeCustomerItems(details));
      notify("error", "Item Removed");
    }
  };

  useEffect(() => {
    if (userCart.length) {
      const total = userCart.reduce((sum, item) => sum + item.price, 0);
      setCartTotal(total);
      // console.log("userCart", userCart);
    }
  }, [userCart]);
  return (
    <>
      {userCart.length > 0 ? (
        <div className={styling.cartWrapper}>
          <div className={styling.cartHeader}>
            <h3>Cart</h3>
            <span className={styling.cartCount}>
              {userCart.length} item{userCart.length > 1 ? "s" : ""}
            </span>
          </div>

          <div className={styling.cartTableWrapper}>
            <table className={styling.UserCart} cellSpacing={0}>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Item name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  {!hideAction ? <th>Action</th> : null}
                </tr>
              </thead>

              <tbody>
                {userCart.map((each, index) => (
                  <tr key={`${each.itemName}-${index}`}>
                    <td>{index + 1}</td>
                    <td>{each.itemName}</td>
                    <td>
                      {each.quantity} {each.measurment}
                    </td>
                    <td>{each.price}</td>
                    {!hideAction ? (
                      <td>
                        <AiOutlineDelete
                          onClick={() => !guestUser && deleteItem(each)}
                          className={`${styling.deleteIcon} ${
                            guestUser ? "guestUserGrey" : ""
                          }`}
                        />
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>

              {/* <tfoot>
                <tr className={styling.totalRow}>
                  <td
                    colSpan={hideAction ? 3 : 4}
                    className={styling.totalLabel}
                  >
                    Total
                  </td>
                  <td className={styling.totalValue}>{cartTotal} ₹</td>
                </tr>
              </tfoot> */}
              <tfoot>
                <tr className={styling.totalRow}>
                  <td colSpan={hideAction ? 4 : 5}>
                    <div className={styling.totalBar}>
                      <span className={styling.totalLabel}>Total</span>
                      <span className={styling.totalValue}>{cartTotal} ₹</span>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      ) : null}
      <ToastContainer />
    </>
  );
}
export default UserCart;
